/**
 * Resolve a userId to a friendly label within the active family. The web build
 * only knows the current user's real name (from the session); other members are
 * shown by a stable short label derived from their membership. Good enough for
 * the mock-first build; the real API will return display names.
 */
import type { MeResponse } from '@solandia/core';

export interface PeopleResolver {
  label(userId: string): string;
  isMe(userId: string): boolean;
}

export function makePeopleResolver(
  me: MeResponse,
  selfLabel: string,
): PeopleResolver {
  const selfId = me.user.id;
  return {
    isMe: (userId) => userId === selfId,
    label(userId) {
      if (userId === selfId) return selfLabel;
      // Other co-parent / trusted person — short, friendly fallback.
      return 'Druhý rodič';
    },
  };
}
